<template>
    <div>
        <div v-for="yItem, i in input_data.y_items" :key="i">
            <div class="y_axis_separation" ></div>
                <el-form-item label-width="0" v-if="input_data.y_items.length > 1" style="display: flex; justify-content: flex-end;" class="remove-y-item-wrapper">
                    <a 
                        @click="removeYItem(i)" 
                        class="btn btn-danger text-white remove-y-item"  
                        v-html="'x'"
                        style="width: 34px; height: 34px; display: inline-flex; align-items: center; justify-content: center;" 
                    >
                    </a>
                </el-form-item>
                <el-form-item label-width="0" >

                    <FormInputTextCol 
                        v-model="input_data.y_items[i].label_name" 
                        :showOn="true"
                        :label="$t('input_table.y_axis_label_name')" 
                        placeholder="ラベル名を入力"
                        classes="y_axis item-left" 
                        :maxlength="constants.INPUT_LIMIT.TEXT_MAX_LENGTH"
                        :required="true"
                        :error="getError(i,'label_name')"
                    />

                    <FormInputSelectCol 
                        v-model="yItem.input_method" 
                        :field="yItem"
                        :showOn="true" 
                        :required="true"
                        :options="inputMethodsData()"
                        classes="y_axis item-center" 
                        @change="onInputMethodChange(yItem, i)"
                        :label="$t('input_table.y_axis_input_method')" 
                        :error="getError(i,'input_method')"
                    />

                    <FormInputSelectCol 
                        v-model="input_data.y_items[i].check_method" 
                        :field="yItem"
                        :showOn="true"
                        :options="checkMethodData(yItem)" 
                        :multiple="true" 
                        classes="y_axis item-left"
                        :label="$t('input_table.y_axis_input_check')" 
                    />

                    <FormInputTextCol 
                        v-model="input_data.y_items[i].display_order" 
                        :showOn="true"
                        type="number"
                        :label="$t('input_table.y_axis_display_order')" 
                        classes="y_axis item-center" 
                        :error="getError(i,'display_order')"
                    />

                    <FormInputSelectCol 
                        v-model="input_data.y_items[i].item_role" 
                        :field="yItem"
                        :showOn="true"
                        :disabled="isItemRoleDisabled()"
                        :options="itemRoleData(yItem)" 
                        classes="y_axis item-left"
                        :label="'項目権限'" 
                    />

                    <FormInputTextCol 
                        v-if="input_methods.isShowSelections(yItem)"
                        v-model="input_data.y_items[i].selections"
                        :showOn="input_methods.isShowSelections(yItem)"
                        :label="$t('input_table.y_axis_selections')" 
                        classes="y_axis item-center" 
                        :error="getError(i,'selections')"
                    />

                    <FormInputTextarea v-if="input_methods.isShowDisplayContent(yItem)"
                        v-model="input_data.y_items[i].display_content"
                        :label="$t('input_table.y_axis_display_content')" 
                        classes="y_axis item-center" 
                        :error="getError(i,'display_content')"
                    />

                    <FormInput2RangeCol 
                        v-if="check_methods.isShowSizeRange(yItem)" 
                        label="軸容量"
                        :modelValue1="input_data.y_items[i].range_from_size"
                        :modelValue2="input_data.y_items[i].range_to_size"
                        @update:modelValue1="input_data.y_items[i].range_from_size = $event"
                        @update:modelValue2="input_data.y_items[i].range_to_size = $event" 
                        :error="getError(i,'range_from_size|range_to_size')"
                    />

                    <FormInputTextCol 
                        :showOn="check_methods.isShowAcceptableExtensions(yItem)" 
                        v-model="input_data.y_items[i].acceptable_extensions" 
                        label="軸許可拡張"
                        classes="y_axis item-left" 
                        maxlength="100"
                        :error="getError(i,'acceptable_extensions')"
                    />

                    <FormInputAttachmentCol :label="$t('input_table.y_axis_attachments')"
                        :showOn="input_methods.isShowAttachment(yItem)" 
                        :modelPath="input_data.y_items[i].item_file_path"
                        :modelUrl="input_data.y_items[i].url_download_file"
                        :field="field"
                        :yCoordinate="input_data.y_items[i].field_key"
                        @update:modelPath="input_data.y_items[i].item_file_path = $event"
                        @update:modelUrl="input_data.y_items[i].url_download_file = $event" 
                        @remove-file="$emit('remove-file', $event)"
                        :error="getError(i,'item_file_path')"
                        classes="y_axis item-center" 
                    />

                    <FormInput2RangeCol v-if="check_methods.isShowDigitRange(yItem)" label="軸桁数"
                        :modelValue1="input_data.y_items[i].range_from_digit"
                        :modelValue2="input_data.y_items[i].range_to_digit"
                        @update:modelValue1="input_data.y_items[i].range_from_digit = $event"
                        @update:modelValue2="input_data.y_items[i].range_to_digit = $event" 
                        :error="getError(i,'range_from_digit')"
                    />

                    <FormInputCalcMatchCol v-if="input_methods.isShowCalculation(yItem)"
                        :error="errors[i] ? errors[i][0] : null "
                        :tableFieldData="input_data"
                        :field="input_data.y_items[i]"
                        :calc_item="input_data.y_items[i].calc_item" 
                        :calc_method="input_data.y_items[i].calc_method"
                        :number_calc="input_data.y_items[i].number_calc" 
                        :calculation="input_data.y_items[i].calculation" 
                        @update:calc_item="input_data.y_items[i].calc_item = $event"
                        @update:calc_method="input_data.y_items[i].calc_method = $event" 
                        @update:number_calc="input_data.y_items[i].number_calc = $event" 
                        @update:calculation="input_data.y_items[i].calculation = $event" 
                    />

                    <FormInputTextCol v-if="input_methods.isShowCalculation(yItem)" label="小数点の桁数"
                        classes="y_axis item-center">
                        <el-input class="bg-gray-item" v-model="input_data.y_items[i].number_decimal"
                            @input="validNumber($event, form[formindex])" />
                    </FormInputTextCol>

                    <FormInputSelectCol v-if="input_methods.isShowCalculation(yItem)" 
                        v-model="input_data.y_items[i].rounding_type"
                        :options="constants.ROUNDING_CALCULATION" 
                        classes="y_axis item-center" 
                        label="丸めルール"
                    />

                </el-form-item>
                <TableCopyYAxisField
                    v-model="input_data.y_items[i].copy_y_key_ref"
                    :y-item="yItem"
                    :form-base="form_base"
                    :field="field"
                    :copy-error="getError(i, 'copy_y_key_ref')"
                />
            </div>
            

        <el-form-item label-width="0" class="table-coordinates">
            <div class="axis_plus mb-16">
                <button type="button" @click="addYItem" class="btn" :disabled="input_data.y_items.length >= 100" >
                    <i class="flaticon2-plus-1" /> <strong>Y</strong> 追加
                </button>
            </div>
            <el-col :md="24" class="x_items">
                <el-col :md="14" v-for="xItem, i in input_data.x_items" :key="i">
                    <el-form-item class="item-fome-base x_axis item-left" :label="$t('input_table.y_axis_label_name')">
                        <input v-model="xItem.label_name" type="text" autocomplete="off" class="el-input__inner" placeholder="X軸ラベル名" :maxlength="input_limit.TEXT_MAX_LENGTH" required />
                        <a @click="removeXItem(i)" v-if="input_data.x_items.length > 1" class="btn btn-danger text-white remove-x-column" v-html="'x'" />
                        
                    </el-form-item>

                    <el-form-item class="item-fome-base item-error">
                        <label class="el-form-item__label" style="min-width: 200px;"></label>
                        <div class="el-form-item__content text-danger" v-if="getError(i,'label_name', 'x_items')">{{ getError(i,'label_name', 'x_items').msg }}</div>
                    </el-form-item>
                    
                </el-col>
                <el-col :md="24" class="axis_plus" >
                    <button type="button" @click="addXItem" class="btn" :disabled="input_data.x_items.length >= 1000">
                        <i class="flaticon2-plus-1" /> <strong>X</strong> 追加
                    </button>
                </el-col>
            </el-col>
            <el-col :md="24">
                <el-form-item class="item-fome-base text-left">
                    <el-checkbox v-model="input_data.x_allow_add"></el-checkbox>
                    <span class="input_table__label ml-3" v-html="$t('input_table.allow_add_x_axis')"></span>
                </el-form-item>
            </el-col>

        </el-form-item>
    </div>
</template>

<script>
import * as constants from "@/core/config/constant"
import * as CheckMethods from "@/core/config/CheckMethods"
import * as InputMethods from "@/core/config/InputMethods"
import FormInputTextCol from "@/view/components/inputs/FormItemCol/InputText"
import FormInputSelectCol from "@/view/components/inputs/FormItemCol/InputSelect"
import FormInput2RangeCol from "@/view/components/inputs/FormItemCol/Input2Range"
import FormInputTextarea from "@/view/components/inputs/FormItemCol/InputTextarea"
import FormInputCalcMatchCol from "@/view/components/inputs/FormItemCol/InputCalcMatch"
import FormInputAttachmentCol from "@/view/components/inputs/FormItemCol/InputAttachment"
import TableCopyYAxisField from "@/view/components/inputs/TableCopyYAxisField"

export default {
    components: {
        FormInputTextCol,
        FormInputSelectCol,
        FormInputTextarea,
        FormInput2RangeCol,
        FormInputCalcMatchCol,
        FormInputAttachmentCol,
        TableCopyYAxisField,
    },

    props: ['form_base', 'value', 'errors', 'field'],
    data() {
        return {
            constants: constants,
            check_methods_opt: constants.CHECK_METHOD,
            input_limit : constants.INPUT_LIMIT,
            check_methods: CheckMethods,
            input_methods: InputMethods,
            input_data: {
                y_items: [],
                x_items:[],
                x_allow_add: false,
            },
            y_field: {
                field_key:'',
                label_name: '',
                check_method: [],
                input_method: null,
                display_order: constants.DISPLAY_ORDER_DEFUALT,
                selections: '',
                display_content: '',
                acceptable_extensions: '',
                item_file_path: '',
                url_download_file: '',
                range_from_size: '',
                range_to_size: '',

                range_from_digit: '',
                range_to_digit: '',
                number_decimal: '',
                calc_item: '',
                calc_method: '',
                number_calc: '',
                calculation: [],
                calc_flg: null,
                rounding_type: null,
                special_processing: '',
                item_role: constants.ITEM_ROLE_DEFAULT,
                item_role_list: constants.ITEM_ROLE,

                show_to_hide: false,
                hide_to_show: false,
                copy_y_key_ref: null,
            },
            x_field : {
                field_key: '',
		        label_name: '',
		        display_order: constants.DISPLAY_ORDER_DEFUALT
            },
        }
    },

    async mounted() {
        if (this.value && this.value.y_items) {
            await this.fillData()
        }

        if (this.input_data.y_items.length < 1) {
            this.addYItem()
        }

        if (this.input_data.x_items.length < 1) {
            this.addXItem()
        }
        this.input_data.y_items.forEach(yItem => {
            if (this.field.item_role === 2 || this.field.item_role === 3) {
                yItem.item_role = this.field.item_role
            }
        })

    },
    methods: {
        fillData() {
            this.input_data.x_allow_add = this.value.x_allow_add
            const yItemsValue = []
            this.value.y_items.map((itemDB) => {
                const itemValue = {}
                Object.keys(this.y_field).map((k) => {
                     itemValue[k] = itemDB[k] || null
                })
                yItemsValue.push(itemValue)
            })
            this.input_data.y_items = yItemsValue
            this.input_data.x_items = this.value.x_items ? this.value.x_items : []

        },
        
        addYItem() {
            if( this.input_data.y_items.length >= 100 ){
                return;
            }
            let cloneRow = Object.assign({}, this.y_field)
            cloneRow.display_order = this.input_data.y_items.length + 1
            cloneRow.field_key = this.$uuid.v4()
            
            // Priority 1: Check field.item_role first
            if (this.field && (this.field.item_role === 2 || this.field.item_role === 3)) {
                cloneRow.item_role = this.field.item_role
            }
            // Priority 2: Check special_processing
            else if( this.field && this.field.special_processing === 3 ){
                cloneRow.item_role = constants.ITEM_ROLE_KEY.ADMIN
            } 
            // Priority 3: Default to USER
            else {
                cloneRow.item_role = constants.ITEM_ROLE_KEY.USER
            }
            
            this.input_data.y_items.push(cloneRow)
        },

        addXItem() {
            if( this.input_data.x_items.length >= 1000 ){
                return;
            }
            let cloneColumn = Object.assign({}, this.x_field)
            cloneColumn.display_order = this.input_data.x_items.length + 1
            cloneColumn.field_key = this.$uuid.v4()
            this.input_data.x_items.push(cloneColumn)
        },
        inputMethodsData() {
            let methods = JSON.parse(JSON.stringify(constants.INPUT_METHOD))
            methods = methods.filter(obj => obj.value !== 10)
            if ([0].includes(this.form_base.special_item)) {
                methods.splice(8, 1)
            }
            return methods
        },

        inputMethodsChange(input) {
            input.check_method = [] // reset check method
        },
        onInputMethodChange(yItem, yItemIndex) {
            this.inputMethodsChange(yItem);
            if (yItem) {
                yItem.copy_y_key_ref = null;
            }
        },
        checkMethodData(input) {
            return CheckMethods.getCheckMethodOptions(input.input_method)
        },
        specialProcessingData(input) {
            return InputMethods.getSpecialProcessingOptions(input)
        },
        itemRoleData(input) {
            return constants.ITEM_ROLE
        },
        specialProcessingChange(input, index) {
            input.check_method=[];
            input.item_role_list = constants.ITEM_ROLE
            if (input.special_processing == constants.SPECIAL_PROCESSING[1].value){
                input.range_from_digit = constants.PASSWORD_LENGTH.min
                input.range_to_digit = constants.PASSWORD_LENGTH.max
                input.check_method=[1,4,8]
                input.item_role = constants.ITEM_ROLE_KEY.USER
            }else if (input.special_processing == constants.SPECIAL_PROCESSING[0].value){
                input.check_method=[1,7]
                input.item_role = constants.ITEM_ROLE_KEY.USER
                input.item_id_parent= {}
                input.copy_id =''
            } else if (input.special_processing == constants.SPECIAL_PROCESSING[3].value){
                input.check_method=[1,13]
                input.item_role = constants.ITEM_ROLE_KEY.USER
                input.item_id_parent= {}
                input.copy_id =''
            } else if (input.special_processing == constants.SPECIAL_PROCESSING[2].value){
                input.item_role = constants.ITEM_ROLE_KEY.ADMIN
            }
            else {
                input.range_from_digit = ''
                input.range_to_digit = ''
                input.item_role_list = constants.ITEM_ROLE_SPECIAL_PROCESSING_EMPTY
                input.item_role = constants.ITEM_ROLE_KEY.USER
            }
            
            if( index ){
                this.input_data.y_items[index].special_processing = input.special_processing
                this.input_data.y_items[index].item_role = input.item_role
                this.$emit('input', this.input_data)
            }
        },
        isItemRoleDisabled() {
            // Disable item_role when parent field has special_processing > 0
            return this.field && this.field.special_processing > 0
        },
        updateItemRolesBasedOnSpecialProcessing() {
            // Update all Y items based on parent field's item_role or special_processing
            if (!this.field) return
            
            this.input_data.y_items.forEach(yItem => {
                // Priority 1: Check field.item_role first (item_role = 2 or 3)
                if (this.field.item_role === 2 || this.field.item_role === 3) {
                    yItem.item_role = this.field.item_role
                }
                // Priority 2: Check special_processing
                else if (this.field.special_processing === 3) {
                    yItem.item_role = constants.ITEM_ROLE_KEY.ADMIN
                }else {
                    // special_processing = 1, 2, 4
                    yItem.item_role = constants.ITEM_ROLE_KEY.USER   // = 1
                }
            })
        },
        checkEditItem() {
            return true
        },
        includeMethod(input, methodID) {
            return input.check_method.includes(methodID)
        },
        getError(i, field, itemType='y_items'){
            const fields = field.split('|')
            if( !this.errors[i] ){
                return null
            }
            console.log(`====== getError i=${i}`, this.errors, {itemType})

            const errors = this.errors[i].filter(er=>fields.indexOf(er.field)>-1 && er.coordinates===itemType)
            if( !errors ){
                return null
            }
            if( errors.length > 0){
                return errors[0]
            }
            return null
        },
        onChangeXColumnHanlder(event){
        },
        removeXItem(index){
            if( this.input_data.x_items.length < 2 ){
                return
            }
            this.input_data.x_items.splice(index, 1)
        },
        removeYItem(index){
            if( this.input_data.y_items.length < 2 ){
                return
            }
            this.input_data.y_items.splice(index, 1)
        },
    },
    watch:{
        input_data : {
            handler(newValue) {
                this.$emit('input', newValue)
            },
            deep: true,
        },
        // Watch for changes in parent field's special_processing
        'field.special_processing': {
            handler(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.updateItemRolesBasedOnSpecialProcessing()
                }
            },
            immediate: false
        },
        'field.item_role': {
            handler(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.updateItemRolesBasedOnSpecialProcessing()
                }
            },
        }
    }
}
</script>

<style lang="scss">
.input-tables {
    .el-select {
        width: 100%;
    }
}
.transition-box {
    &.input-tables {
        color: #606266 !important;
    }

    .el-form-item.required .el-form-item__label::after {
        content: "*";
        color: red;
    }
}

.y_axis_separation {
    display: block;
    margin-bottom: 30px;

    &::before {
        width: 50%;
        margin-left: 25%;
        height: 5px;
        border-bottom: 2px solid #EBEDF3;
        content: "  ";
        display: block;
    }
}

.axis-target-inline {
    font-weight: bold;
    font-style: normal;
    display: inline-block;
    margin: 0 2px;
    color: #606266;
}

.input_table__label {
    color: #606266;
}

.y_axis,
.x_axis {
    .el-form-item__label {
        position: relative;

        &::before {
            content: "Y";
            position: relative;
            top: -1px;
            margin-right: 2px;
            font-weight: bold;
        }
    }

    &.item-center .el-form-item__label {
        text-align: center;
    }
}

.x_axis {
    .el-form-item__label{
        &::before {
            content: "X";
        }

        &::after {
            content: "*";
            color: red;
        }
    }
}

.axis_plus {
    text-align: left;
    margin-bottom: 15px;
    margin-left: 200px;
    button {
        background-color: #00aff0;
        padding: 5px 15px;
        color: var(--white);
        font-size: 1.2rem;
        i {
            color: var(--white);
            font-size: 1.5rem;
        }
        &:hover {
            background-color: var(--primary);
            color: var(--white);
        }

        &:disabled {
            cursor: unset;
            background-color: rgba(9, 30, 66, 0.48)
        }
        
    }
}
.x_items {
    .el-form-item__content {
        display: flex;
        .remove-x-column {
            margin-left: 4px;
            
        }
    }

    .x_axis_plus {
        text-align: left;
        margin-left: 200px;

        button {
            background-color: #00aff0;
            padding: 5px 15px;
            color: var(--white);
            i {
                color: var(--white);
            }
            &:hover {
                background-color: var(--primary);
            }

            &:disabled {
                cursor: unset;
                background-color: rgba(9, 30, 66, 0.48)
            }
            
        }
        
    }

    .el-form-item.is-required .el-form-item__label {
        &::after {
            content: "*";
            color: red;
        }

        &::before {
            content: "";
        }
    }
}
.file-select {
    display: none;
}

@media only screen and (max-width: 992px){
   .x_items {
        .el-form-item__content {
            width: 100%;
            display: inline-flex;
        }
        .item-error {
            .el-form-item__content {
                display: block;
                text-align: left;
            }
            .el-form-item__label {width: 100%;}

        }
   }
}
</style>